/* global window */
import React from 'react';
import { Provider } from 'react-redux';
import { t } from '@lingui/macro';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { I18nProvider } from '@lingui/react';
import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
import { AnalyticsProvider } from 'use-analytics';
import {
  Header,
  ThemeProvider as EmotionThemeProvider,
  Container
} from '@3plearning/react-components';
import { ThemeProvider } from 'styled-components';
import ConserveParameters from '../../helpers/conserve-parameters';
import Storage from '../../helpers/local-storage';
import css from './entry-app.scss';
import courseAssignTheme from '../../themes/course-assign-theme';
import '../../styles/core.scss';
import BasicApp from './basic-app';
import CourseAssign from '../course-assign/course-assign';
import FilterBar from '../../components/filter-bar';
import SwitchToOldAssign from '../../components/switch-to-old-assign/switch-to-old-assign';
import { MxAnalyticsProvider } from '../../analytics';

ConserveParameters(['username', 'password', 'userToken']);
Storage.namespace = 'course-assign';

export default class EntryApp extends BasicApp {
  render = (store, i18n) => {
    // TODO: 4. DEFINE THE TOP-LEVEL ROUTES FOR YOUR APPLICATION'S COMPONENTS HERE

    // When executing on demo, QA, or production, the host app will inject a property
    // called pppAppConfig into the global window variable.  This will provide the
    // base name of the app.  Most of the time that will be an empty string, but in
    // case it is not, we will extract it and pass it to the router, below.

    // eslint-disable-next-line no-underscore-dangle
    const appConfig = window._env_;
    const BASE_NAME = appConfig ? appConfig.BaseName : '';

    const showSwitchToOldAssign =
      // getConfiguration('showSwitchToOldAssign') ||
      false;
    /* Initialize analytics & load plugins */
    const analytics = Analytics({
      app: 'course-assign',
      debug: false,
      plugins: [
        googleAnalytics({
          trackingId: 'UA-74202440-35'
        })
      ]
    });

    // NOTE: We have used a "render" attribute, rather than "component" to specify what
    //       should be rendered.  This allows us to pass options to the component. You
    //       can obviously simplify things if your components don't need any.
    return (
      <I18nProvider i18n={i18n}>
        <Provider store={store}>
          <AnalyticsProvider instance={analytics}>
            <MxAnalyticsProvider>
              <Router basename={BASE_NAME}>
                <EmotionThemeProvider theme={courseAssignTheme}>
                  <ThemeProvider theme={courseAssignTheme}>
                    <div className={css.app}>
                      <Header
                        title={i18n._(
                          t('entryapp.header.title')`Assign & Review`
                        )}
                        subtitle={i18n._(
                          t('entryapp.header.courses')`Courses (Activities)`
                        )}
                        className={css.header}
                      >
                        <div className={css.buttonsContainer}>
                          <FilterBar i18n={i18n} />
                          {showSwitchToOldAssign && (
                            <SwitchToOldAssign i18n={i18n} />
                          )}
                        </div>
                      </Header>
                      <Container className={css['container-wrapper']}>
                        <Switch>
                          <Route
                            path="/"
                            render={() => <CourseAssign i18n={i18n} />}
                          />
                        </Switch>
                      </Container>
                    </div>
                  </ThemeProvider>
                </EmotionThemeProvider>
              </Router>
            </MxAnalyticsProvider>
          </AnalyticsProvider>
        </Provider>
      </I18nProvider>
    );
  };
}
window.EntryApp = EntryApp;



// WEBPACK FOOTER //
// ./containers/app/entry-app.js